var _excluded = ["style", "className", "children", "size", "iconType"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-helpers';
import Icon from '@adsk/alloy-icon';
import theme from '@adsk/alloy-theme';
import { buttonTypePropType } from '../consts';
import BasicButton from './BasicButton';
/**
 * Icon Button.
 */

var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      iconType = _ref.iconType,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(BasicButton, _extends({
    ref: ref,
    className: className,
    style: [{
      padding: 0,
      width: size,
      height: size,
      color: theme.colors.charcoal700,
      '&:hover': {
        color: theme.colors.adskBlue500
      },
      '&:active': {
        color: theme.colors.adskBlue500
      },
      '&:focus': {
        color: theme.colors.adskBlue700
      },
      '&[disabled]': {
        color: theme.colors.charcoal500,
        cursor: 'not-allowed'
      }
    }, style]
  }, props), children || iconType && /*#__PURE__*/React.createElement(Icon, {
    size: size,
    type: iconType
  }));
});
IconButton.displayName = 'IconButton';
IconButton.defaultProps = {
  type: 'button',
  disabled: false,
  size: 24
};
IconButton.propTypes = {
  /** BasicButton's content */
  children: PropTypes.node,

  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** button html type, eg: submit */
  type: buttonTypePropType,

  /** Icon size, passed only when using `iconType` */
  size: PropTypes.number,

  /** Icon type to display on left */
  iconType: PropTypes.oneOf(Object.values(Icon.TYPES))
};
export default Object.assign(IconButton, {
  TYPES: Icon.TYPES
});
//# sourceMappingURL=IconButton.js.map